module.exports = "ul{\n\tpadding: 0;\n}\nul li{\n\tlist-style-type: none;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/selecao-responsaveis/selecao-responsaveis.component.css
// module id = ./src/app/selecao-responsaveis/selecao-responsaveis.component.css
// module chunks = main